import React from "react";

import useScrollToTop from "../../../hooks/useScollToTop";

import UserModal from "./UserModal";

import LinkClubModal from "./users-admin/components/LinkClubModal";
import SendMessageModal from "./users-admin/components/SendMessageModal";
import UsersCardsMobile from "./users-admin/components/UsersCardsMobile";
import UsersFilters from "./users-admin/components/UsersFilters";
import UsersHeader from "./users-admin/components/UsersHeader";
import UsersPagination from "./users-admin/components/UsersPagination";
import UsersSummaryBar from "./users-admin/components/UsersSummaryBar";
import UsersTableDesktop from "./users-admin/components/UsersTableDesktop";

import useUsersAdmin from "./users-admin/hooks/useUsersAdmin";

export default function Users() {
  useScrollToTop();

  const usersAdmin = useUsersAdmin();

  return (
    <div className="w-full pb-10 pt-[96px] font-satoshi">
      <div className="mx-auto max-w-[1450px] px-4">
        <UsersHeader
          totalUsers={usersAdmin.stats.totalUsers}
          totalBadges={usersAdmin.stats.totalBadges}
          totalClubs={usersAdmin.stats.totalLinkedClubs}
          totalActeurs={usersAdmin.stats.totalActeurs}
        />

        <div className="mt-5">
          <UsersFilters
            filters={usersAdmin.filters}
            roleOptions={usersAdmin.roleOptions}
            loading={usersAdmin.loading}
            exportingExcel={usersAdmin.actions.exportingExcel}
            onExportExcel={usersAdmin.actions.exportExcel}
          />
        </div>

        <UsersSummaryBar
          stats={usersAdmin.stats}
          filters={usersAdmin.filters}
          roleOptions={usersAdmin.roleOptions}
          displayedCount={usersAdmin.rows.length}
          page={usersAdmin.pagination.page}
          pageCount={usersAdmin.pagination.pageCount}
          loading={usersAdmin.loading}
        />

        <div className="mt-5">
          <UsersTableDesktop
            rows={usersAdmin.rows}
            loading={usersAdmin.loading}
            badgesByUser={usersAdmin.badgesByUser}
            onEdit={usersAdmin.editModal.open}
            onDelete={usersAdmin.actions.removeUser}
            onLinkClub={usersAdmin.linkClubModal.open}
            onMessage={usersAdmin.messageModal.open}
            onCoachBadge={usersAdmin.actions.exportCoachBadge}
            exportingCoachBadgeUserId={
              usersAdmin.actions.exportingCoachBadgeUserId
            }
            onToggleCoachBadgePrinted={
              usersAdmin.actions.toggleCoachBadgePrinted
            }
            onToggleCoachBadgeReceived={
              usersAdmin.actions.toggleCoachBadgeReceived
            }
            coachBadgeUpdatingByUser={
              usersAdmin.actions.coachBadgeUpdatingByUser
            }
          />

          <UsersCardsMobile
            rows={usersAdmin.rows}
            loading={usersAdmin.loading}
            badgesByUser={usersAdmin.badgesByUser}
            onEdit={usersAdmin.editModal.open}
            onDelete={usersAdmin.actions.removeUser}
            onLinkClub={usersAdmin.linkClubModal.open}
            onMessage={usersAdmin.messageModal.open}
            onCoachBadge={usersAdmin.actions.exportCoachBadge}
            exportingCoachBadgeUserId={
              usersAdmin.actions.exportingCoachBadgeUserId
            }
            onToggleCoachBadgePrinted={
              usersAdmin.actions.toggleCoachBadgePrinted
            }
            onToggleCoachBadgeReceived={
              usersAdmin.actions.toggleCoachBadgeReceived
            }
            coachBadgeUpdatingByUser={
              usersAdmin.actions.coachBadgeUpdatingByUser
            }
          />
        </div>

        <UsersPagination
          page={usersAdmin.pagination.page}
          pageCount={usersAdmin.pagination.pageCount}
          setPage={usersAdmin.pagination.setPage}
          loading={usersAdmin.loading}
        />
      </div>

      <UserModal
        isOpen={usersAdmin.editModal.isOpen}
        onClose={usersAdmin.editModal.close}
        onSubmit={usersAdmin.editModal.submit}
        user={usersAdmin.editModal.currentUser}
      />

      <LinkClubModal modal={usersAdmin.linkClubModal} />

      <SendMessageModal modal={usersAdmin.messageModal} />
    </div>
  );
}